import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output
} from '@angular/core';
import { ICoordinatesEvent, IHsl, IHsv } from './color-picker.type';

@Component({
  selector: 'bixi-color-saturation',
  exportAs: 'bixiColorSaturation',
  host: {
    '[class.bixi-color-saturation]': 'true',
    '[style.background]': 'background'
  },
  template: `
    <div class="bixi-color-saturation-white" bixi-coordinates (coordinatesChange)="onCoordinatesChange($event)">
      <div class="bixi-color-saturation-black"></div>
      <div class="bixi-color-saturation-pointer" [style.top.%]="pointerTop" [style.left.%]="pointerLeft">
        <div class="bixi-color-circle"></div>
      </div>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BixiColorSaturationComponent implements OnChanges {
  background!: string;
  pointerTop!: number;
  pointerLeft!: number;
  @Input() hsv: IHsv;
  @Input() hsl: IHsl;
  @Output() colorChange = new EventEmitter<IHsv>();

  ngOnChanges() {
    this.background = `hsl(${this.hsl.h}, 100%, 50%)`;
    this.pointerTop = -(this.hsv.v * 100) + 1 + 100;
    this.pointerLeft = this.hsv.s * 100;
  }

  onCoordinatesChange(event: ICoordinatesEvent) {
    const { width, height, left, top } = event;
    const saturation = left / width;
    let bright = -(top / height) + 1;
    bright = bright > 0 ? bright : 0;
    bright = bright > 1 ? 1 : bright;
    const hsva: IHsv = {
      h: this.hsl.h,
      s: saturation,
      v: bright,
      a: this.hsl.a
    };
    this.colorChange.emit(hsva);
  }
}
